import React from 'react';
import { SectionHeader } from '../SectionHeader';
import { CtaButton } from '../CtaButton';
const questions = ['What should you investigate first?', 'Which findings deserve closer attention?', 'How do you organize your examination without overlooking important information?', 'And when should you consider further medical evaluation?'];
export function ProblemSection() {
  return <section className="w-full bg-paper px-5 py-16 sm:py-24" data-id="element-284" data-mp="3vozzok1m63v5">
      <SectionHeader eyebrow="Stop feeling overwhelmed by complex low back pain assessments" title="You Know the Anatomy. But Do You Have a Clear Process for Every Assessment?" data-id="element-285" data-mp="3vrvy09hdiuk4" />

      <div className="mx-auto mt-10 grid max-w-5xl gap-10 lg:grid-cols-2 lg:gap-14" data-id="element-286" data-mp="3ltolc2u4aynx">
        <div className="space-y-5 text-lg leading-relaxed text-slate-700" data-id="element-287" data-mp="3qsizusl1y128">
          <p data-id="element-288" data-mp="1k1a1gy80jk4v">You have studied spinal anatomy, biomechanics, orthopedic tests, and rehabilitation principles.</p>
          <p data-id="element-289" data-mp="1oyabfk7zh719">
            But when a patient presents with persistent low back pain, symptoms extending into the leg, or findings that don’t fit the expected
            pattern, organizing everything into a coherent clinical picture can be challenging.
          </p>
        </div>

        <ul className="space-y-3" data-id="element-290" data-mp="1wev0yq9s3lr0">
          {questions.map(q => <li key={q} className="flex items-start gap-4 rounded-xl bg-white p-4 shadow-sm ring-1 ring-slate-200" data-id="element-291" data-mp="1se1e8082oczp">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-flame font-display text-xl font-black text-white" data-id="element-292" data-mp="14q06gtipx0lc">
                ?
              </span>
              <span className="pt-1 text-lg font-semibold leading-snug text-ink" data-id="element-293" data-mp="1dpx2jg7ft1qf">{q}</span>
            </li>)}
        </ul>
      </div>

      <div className="mx-auto mt-12 max-w-3xl space-y-5 text-lg leading-relaxed text-slate-700" data-id="element-294" data-mp="18p91s2tep6j0">
        <p data-id="element-295" data-mp="2p2z9djjqicxe">
          I created the <strong className="text-ink" data-id="element-296" data-mp="2k5qxu1t3d754">Low Back Pain Assessment Blueprint™</strong> to help you approach these questions with a
          more structured educational framework.
        </p>
        <p data-id="element-297" data-mp="1hunnboaldv7j">
          Instead of jumping between scattered notes, textbooks, and saved resources, you’ll have a dedicated collection covering the initial
          interview, clinical screening, physical examination, reasoning, and educational case studies.
        </p>
        <p className="border-l-4 border-brand-dark pl-5 font-display text-2xl font-bold uppercase leading-tight text-ink" data-id="element-298" data-mp="1vrkczmez56mu">
          The goal isn’t to make every patient fit the same pathway. It’s to help you organize your assessment process while adapting your
          decisions to each patient’s presentation.
        </p>
      </div>

      <CtaButton label="I Want a Clearer Assessment Process" sub="One-time payment of $27 · Instant access · 7-day guarantee" data-id="element-299" data-mp="1ct81hu0lbko3" />
    </section>;
}